import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

import {
  selectedRowIdsAtom,
  orderbyAtom,
  sortOrderAtom,
  paginationConfigAtom,
  policyIdFilterAtom,
  filterValuesAtom,
  sourceTypeAtom,
  agentKeyAtom,
} from './AssetListing/state';
import {
  policyIdFilterAtom as pcPolicyIdFilterAtom,
  appliedHostIdsAtom,
} from '../PCDashboard/state';

export function useOnCompanyChangePCResetAtoms() {
  const resetSelectedHostIds = useResetAtom(appliedHostIdsAtom);
  const resetPolicyIdFilterAtom = useResetAtom(policyIdFilterAtom);
  const resetOrderbyAtom = useResetAtom(orderbyAtom);
  const resetSortOrderAtom = useResetAtom(sortOrderAtom);
  const resetSelectedRowIdsAtom = useResetAtom(selectedRowIdsAtom);
  const resetPcPolicyIdFilterAtom = useResetAtom(pcPolicyIdFilterAtom);
  const resetFilterValuesAtom = useResetAtom(filterValuesAtom);
  const resetSourceTypeAtom = useResetAtom(sourceTypeAtom);
  const resetAgentKeyAtom = useResetAtom(agentKeyAtom);
  const [paginationConfig, setPaginationConfig] = useAtom(paginationConfigAtom);

  const resetAtoms = () => {
    resetSelectedHostIds();
    resetPolicyIdFilterAtom();
    resetPcPolicyIdFilterAtom();
    resetOrderbyAtom();
    resetSortOrderAtom();
    resetSelectedRowIdsAtom();
    resetFilterValuesAtom();
    resetSourceTypeAtom();
    resetAgentKeyAtom();

    // Only reset page number, preserve page size
    setPaginationConfig({
      ...paginationConfig,
      page: 1,
    });
  };

  return resetAtoms;
}
